import { apiPost } from './client';
import type { AuthResponse, CodeSentResult, GoogleAuthResponse } from './auth.types';

export const authApi = {
  /** Bước 1 đăng ký: server gửi mã 6 số về email, CHƯA tạo tài khoản. Gọi lại = gửi lại mã. */
  register: (body: { email: string; password: string; displayName?: string }) => apiPost<CodeSentResult>('/auth/register', body),
  /** Bước 2 đăng ký: đúng mã thì tạo tài khoản và trả token. */
  verifyRegistration: (body: { email: string; code: string }) => apiPost<AuthResponse>('/auth/register/verify', body),
  login: (body: { email: string; password: string }) => apiPost<AuthResponse>('/auth/login', body),
  /** Gửi ID token Google để server xác minh — tạo tài khoản mới hoặc tự liên kết theo email. */
  google: (idToken: string) => apiPost<GoogleAuthResponse>('/auth/google', { idToken }),
  /** Quên mật khẩu bước 1 — luôn thành công dù email có tài khoản hay không. */
  forgotPassword: (body: { email: string }) => apiPost<CodeSentResult>('/auth/password/forgot', body),
  /** Quên mật khẩu bước 2: đúng mã thì đổi mật khẩu và trả token. */
  resetPassword: (body: { email: string; code: string; newPassword: string }) => apiPost<AuthResponse>('/auth/password/reset', body),
};
